import managers from './managers';
import candidates from './candidates';
import clients from './clients';
import corpClientTags from './corpClientTags';
import partners from './partners';
import admins from './admins';
import candidate from './candidate';
import dossiers from './dossiers';
import counters from './counters';

export default {
  namespaced: true,
  modules: {
    managers,
    clients,
    corpClientTags,
    candidates,
    candidate,
    dossiers,
    partners,
    admins,
    counters,
  },
};
